import { useEffect, useState } from "react";
import { useFeatureFlagVariantKey } from "posthog-js/react";

const usePricing = () => {
  const variant = useFeatureFlagVariantKey("cro-web-117-pricing-testing-2-0");

  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPrices() {
      const currency = localStorage.getItem("mob_currency");
      try {
        const query = new URLSearchParams();

        if (variant) query.append("experimentGroup", variant as string);
        if (currency) query.append("currency", currency);

        const url = `/api/plus/prices${
          query.toString().length ? "?" : ""
        }${query.toString()}`;

        const res = await fetch(url);
        const data = await res.json();

        if (!data?.prices?.length) {
          throw new Error("No prices found");
        }

        setPrices(data.prices);
      } catch (err) {
        console.error("Failed to fetch experiment prices:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    fetchPrices();
  }, [variant]);

  return {
    prices,
    loading,
    error,
    variant,
  };
};
export default usePricing;
